import Datalayer from './../datalayer/datalayer';

/**
 * Product
 *
 * @module product
 */
const component = {

    /**
     * Init component
     *
     * @returns {undefined}
     */
    init: () => {

        /**
         * Product module api
         *
         * @global
         */
        window.theme.product = component;
    },

    /**
     * Load product object by handle.
     *
     * @public
     * @method
     * @name loadProduct
     * @todo Implement a test for this function.
     * @param {string} handle Product handle.
     * @param {string} extended Extend product data.
     * @returns {Promise} Promise object represents a product.
     */
    loadProduct: (handle, extended) => {

        return new Promise((resolve, reject) => {

          let cache = component.getCache(handle);

            if (cache) {

                if (!cache.extended && extended) {

                    Datalayer.getProduct(handle).then(product => {
                        resolve(product);
                    });

                }  else {

                    resolve(cache);
                }

            } else {

                Datalayer.getProduct(handle).then(product => {
                    let data = component.normalizeData(product);
                    component.cache( data.product );
                    resolve(data.product);
                });
            }
        });
    },

    /**
     * Make a request to get product data.
     *
     * @public
     * @method
     * @name request
     * @todo Implement a test for this function.
     * @param {string} handle Product handle.
     * @param {string} extended Extend product data.
     * @returns {Promise} Promise object represents a product.
     */
    request: (handle, extended) => {

        return new Promise((resolve, reject) => {

            // let url = (extended) ? '/products/' + handle + '?view=json' : '/products/' + handle + '.json';
            let url = window.Shopify ? window.Shopify.routes.root + (extended) ? '/products/' + handle + '?view=json' : '/products/' + handle + '.json' : (extended) ? '/products/' + handle + '?view=json' : '/products/' + handle + '.json';

            fetch(url).then(resp => {

                return resp.json();

            }).then(data => {

                if (data.product) {
                    data = component.normalizeData(data);

                    component.cache(data.product);

                    resolve(data.product);

                } else {

                    reject(data);
                }
            }).catch(function(error) {
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Normalize product data.
     *
     * @private
     * @method
     * @name normalizeData
     * @todo Implement a test for this function.
     * @param {object} data Request data.
     * @returns {object} Normalized data.
     */
    normalizeData: data => {
        if (data.product_metafields) {
            data.product.product_metafields = data.product_metafields;
        }

        if (data.variants_metafields) {
            data.product.variants_metafields = data.variants_metafields;
        }

        // Fix options
        if (data.options_with_values) {
            data.product.options = data.options_with_values;
        }

        // Add options by name
        if (data.options_by_name) {
            data.product.options_by_name = data.options_by_name;
        }

        // Compare at price
        if (data.compare_at_price) {
            data.product.compare_at_price = data.compare_at_price;
        }

        // Compare at price varies
        if (data.compare_at_price_varies) {
            data.product.compare_at_price_varies = data.compare_at_price_varies;
        }

        // Add extended flag
        if (data.extended) {
            data.product.extended = true;
        }

        // Fix images
        if (data.product.extended) {
            data.product.images = data.images;
        }

        // Url
        data.product.url = window.location.origin + '/products/' + data.product.handle;

        return data;
    },

    /**
     * Check if a product has variants.
     *
     * @public
     * @method
     * @name hasVariants
     * @param {object} product Product data.
     * @returns {boolean} Product has variants or not.
     */
    hasVariants: product => {

        if(product.options.length == 1 && product.options[0].values.length == 1) {

            return false;

        } else {

            return true;
        }
    },

    /**
     * Cache a product data.
     *
     * @private
     * @method
     * @name request
     * @param {object} product Product data.
     * @returns {boolean}
     */
    cache: product => {

        let productValue = JSON.stringify(product);

        if (product.handle && productValue.length < 50000) {

            try {

                sessionStorage.setItem(product.handle, productValue);

                return true;

            } catch (error) {

                return false;
            }

        } else {

            return false;
        }
    },

    /**
     * Get product from cache.
     *
     * @private
     * @method
     * @name request
     * @param {string} handle Product handle.
     * @param {string} extended Extend product data.
     * @returns {Promise} Promise object represents a product.
     */
    getCache: handle => {

        return JSON.parse(sessionStorage.getItem(handle));
    },

    /**
     * Get variant data
     *
     * @public
     * @method
     * @name getVariant
     * @param {integer} variantId Variant id.
     * @param {object} product Product data.
     * @returns {object} Variant data.
     */
    getVariant: (variantId, product) => {

        let variantData = null;

        if (product && product.variants) {

            product.variants.forEach(variant => {

                if (variant.id == variantId)
                    variantData = variant;
            });
        }

        return variantData;
    }
};

export default component;
